export default __webpack_public_path__ + "static/media/lib-11.9d2555c9.webp";